<rid-egg-carton-sums
  (finished)="$router.navigate(['/mechanics/formule'])"
  [typedAnswers]="typedAnswers()"
  [numbers]="[
    [18, 25],
    [43, 18],
    [17, 13],
    [40, 17],
  ]"
  class="h-dvh"
/>
